import React from "react";
import classes from "./Events.module.scss";
import CustomImage from "../../CustomImage";
import PhoneIcon from "../../UI/Icons/PhoneIcon";
import MailIcon from "../../UI/Icons/MailIcon";
import { EVENT_ITEMS } from "../../../utils/constants";

const Events: React.FC = () => {
  return (
    <section id="b2b-networking-events" className={classes["ev-section"]}>
      <div className={classes["ev-container"]}>
        <h2 className={classes["ev-heading"]}>
          B2B Networking{" "}
          <span className={classes["ev-heading-accent"]}>
            Events &amp; Webinars
          </span>
        </h2>
        <p className={classes["ev-subtext"]}>
          Exclusive platforms for University Representatives to engage directly
          with KC's leading Study Abroad Partners across India and international
          locations.
        </p>

        <div className={classes["ev-grid"]}>
          {EVENT_ITEMS.map((item) => (
            <article key={item.id} className={classes["ev-card"]}>
              <div className={classes["ev-thumbnail"]}>
                <CustomImage
                  src={item.thumbnailUrl}
                  alt={item.thumbnailAlt}
                  layout="fill"
                  objectFit="cover"
                />
              </div>

              <div className={classes["ev-body"]}>
                <span className={classes["ev-category"]}>{item.category}</span>
                <h3 className={classes["ev-title"]}>{item.title}</h3>
                <span className={classes["ev-divider"]} aria-hidden="true" />

                {item.paragraphs.map((paragraph, idx) => (
                  <p key={idx} className={classes["ev-paragraph"]}>
                    {paragraph}
                  </p>
                ))}

                <div className={classes["ev-connect-card"]}>
                  <p className={classes["ev-connect-title"]}>Connect with us</p>

                  <div className={classes["ev-connect-row"]}>
                    <span className={classes["ev-connect-icon"]}>
                      <CustomImage
                        src="/images/contcatus/user-icon.svg"
                        alt="User"
                        width={16}
                        height={16}
                      />
                    </span>
                    <span className={classes["ev-connect-text"]}>
                      {item.contact.name}
                    </span>
                  </div>

                  <div className={classes["ev-connect-row"]}>
                    <span className={classes["ev-connect-icon"]}>
                      <MailIcon />
                    </span>
                    <a
                      className={classes["ev-connect-link"]}
                      href={`mailto:${item.contact.email}`}
                    >
                      {item.contact.email}
                    </a>
                  </div>

                  <div className={classes["ev-connect-row"]}>
                    <span className={classes["ev-connect-icon"]}>
                      <PhoneIcon color="#226CF5" />
                    </span>
                    <a
                      className={classes["ev-connect-link"]}
                      href={`tel:${item.contact.phone.replace(/\s+/g, "")}`}
                    >
                      {item.contact.phone}
                    </a>
                  </div>
                </div>

                <div className={classes["bottom-container"]}>
                  <div className={classes["bottom-divider"]}></div>

                  <p className={classes["bottom-text"]}>
                    We sincerely look forward to your participation and to
                    further strengthening our successful partnership.
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Events;
